export default __webpack_public_path__ + "static/media/no-data.7c647fc2.svg";